// extracted by mini-css-extract-plugin
export default {"AdminInputNumber":"styles_AdminInputNumber__I5LBG","inputNumber":"styles_inputNumber__iaK5z","danger":"styles_danger__FqkgJ"};